import { USER_SERVICE_URL } from 'config';

export const USER_V1_URL = `${USER_SERVICE_URL}/api/v1/user`;

export const AUTH_V1_URL = `${USER_SERVICE_URL}/api/v1/auth`;
